<form class="dynamic-form" [formGroup]="internalForm">
  <ng-container
    *ngFor="let field of config"
    bomDynamicField
    [config]="field"
    [group]="internalForm"
    [showHentFraMinProfilButton]="field.name === firstAutoFillElementName"
    [hentFraMinProfilButton]="hentFraMinProfilButton"
  >
  </ng-container>
</form>
